import FondationsEntertainmentModel from '@/models/services/fondations/EntertainmentModel';
import ShopServiceModel             from '@/models/ShopServiceModel';
import doc                          from '@widesk-core/decorators/doc';
import model                        from '@widesk-core/decorators/model';
import Translatable                 from '@widesk-core/models/traits/Translatable';

@model.urnResource('entertainment')
@doc.path('/entertainments/{?id}')
export default class EntertainmentModel extends Translatable(ShopServiceModel, {
	'title': true,
}) {
	private declare _tsFilters: {
		'createdAt[after]': string;
		'createdAt[before]': string;
		'createdAt[strictly_after]': string;
		'createdAt[strictly_before]': string;
		'entertainmentStatus': id;
		'entertainmentStatus.reference': 'enabled' | 'disabled';
		'entertainmentUrn': Urn;
		'label': string;
		'slug': id;
		'updatedAt[after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'updatedAt[strictly_before]': string | Date;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'label': string;
		'position': string;
		'updatedAt': string;
	};

	get entertainmentUrn(): Urn {
		return this.get('entertainmentUrn');
	}

	@doc.modelUrn(FondationsEntertainmentModel) declare entertainment: FondationsEntertainmentModel;
	@doc.string declare label: string;
	@doc.number declare position: number;
	@doc.string declare slug: string;
	@doc.string declare timezone: string;

	@doc.string declare imageLandscape: string; // Cette propriété n'existe pas sur l'api
	@doc.string declare imageLandscapeBlur: string; // Cette propriété n'existe pas sur l'api
	@doc.string declare imagePortrait: string; // Cette propriété n'existe pas sur l'api
	@doc.string declare imagePortraitBlur: string; // Cette propriété n'existe pas sur l'api

	public get title() {
		return this.label;
	}
}